import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandlerThunk } from '../../App/App.thunk';
import { sourceControlService } from './SourceControl.service';
import { CreateSourceDto, UpdateSourceDto } from './SourceControl.type';

const THUNK_PREFIX = 'sourceControl';

export const getSourceControlListThunk = createAsyncThunk(
  `${THUNK_PREFIX}/getSourceControlListThunk`,
  async (params: { q?: string; page?: number | string; sort?: string }, thunkAPI) => {
    try {
      const response = await sourceControlService.getList(params);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const createSourceControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/createSourceControlThunk`,
  async (source: CreateSourceDto, thunkAPI) => {
    try {
      const response = await sourceControlService.create(source);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const updateSourceControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/updateSourceControlThunk`,
  async (source: UpdateSourceDto, thunkAPI) => {
    try {
      const response = await sourceControlService.update(source);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const deleteSourceControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/deleteSourceControlThunk`,
  async (id: number, thunkAPI) => {
    try {
      await sourceControlService.delete(id);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
